import React from "react";
import { NavLink } from "react-router-dom";

const SettingsSidebar = () => {

    const menus = [
        {
            name: "General",
            path: "/settings/general",
        },
        // {
        //     name: "SEO",
        //     path: "/settings/seo",
        // },
        // {
        //     name: "Tags",
        //     path: "/settings/tags",
        // },
        {
            name: "SMTP Credentials",
            path: "/settings/SMTP",
        },
        {
            name: "Call Credentials",
            path: "/settings/call",
        },
        // {
        //     name: "Leads",
        //     path: "/settings/leads",
        // },
        // {
        //     name: "Support",
        //     path: "/settings/support",
        // },
        // {
        //     name: "Finance",
        //     path: "/settings/finance",
        // },
    ];

    return (
          <div className="settings-tabs-wrapper">

        <div className="settings-tabs-header">
            <div>
                <h4 className="sidebar-title mb-0">Settings</h4>
                <p className="sidebar-subtitle mb-0">
                    Manage your configuration
                </p>
            </div>
        </div>

        <div className="settings-tabs">
            {menus.map((menu) => (
                <NavLink
                    key={menu.path}
                    to={menu.path}
                    className={({ isActive }) =>
                        `settings-tab ${
                            isActive ? "active" : ""
                        }`
                    }
                >
                    {menu.name}
                </NavLink>
            ))}
        </div>

    </div>
        // <div>
        //     <div className="sidebar-header">
        //         <h4 className="sidebar-title">Settings</h4>
        //         <p className="sidebar-subtitle">Manage your configuration</p>
        //     </div>
        //     <ul className="list-group list-group-flush">

        //         {menus.map((menu, index) => (

        //             <li
        //                 key={index}
        //                 className="list-group-item p-0 border-0"
        //             >

        //                 <NavLink
        //                     to={menu.path}
        //                     className={({ isActive }) =>
        //                         `d-block px-4 py-3 text-decoration-none fw-medium ${isActive
        //                             ? "bg-primary text-white"
        //                             : "text-dark"
        //                         }`
        //                     }
        //                 >
        //                     {menu.name}
        //                 </NavLink>

        //             </li>

        //         ))}

        //     </ul>
        // </div>

    );
};

export default SettingsSidebar;